module.exports = __webpack_public_path__ + "f147495964.svg";